import { Theme } from '@material-ui/core/styles';

export const getMuiDialog = (theme: Theme): Record<string, unknown> => ({
  MuiDialog: {
    paper: {
      boxShadow: `0px 12px 36px ${theme.palette.grey[500]}`,
      margin: 0,

      [theme.breakpoints.up('sm')]: {
        height: 'initial',
        margin: '32px',
        maxHeight: 'calc(100vh - 48px)', // - 48px = 24px padding top and bottom
        minHeight: '360px',
        width: '480px',
      },

      [`@media (min-height: 360px)`]: {
        minHeight: '360px - 48px', // - 48px = 24px padding top and bottom
      },

      [`@media (max-height: 359px)`]: {
        minHeight: 'calc(100vh - 48px)', // - 48px = 24px padding top and bottom
      },
    },
  },
});
